import { useEffect } from "react";
import { useLocale } from "@genius-tracker/i18n/react";
import { useToast } from "./Toast.js";
import { setRateLimitNoticeListener } from "../lib/rateLimitNotice.js";

/**
 * GT-UI-API-RATE-LIMIT-REQUEST-STORM-FIX-02 — renders one controlled
 * "too many requests" toast when the API rate-limits a request (HTTP
 * 429). Subscribes to the module-level notifier emitted by the
 * QueryClient cache (`lib/rateLimitNotice.ts`), which is already
 * debounced so a 429 burst shows a single message. Mount once, inside
 * both `<ToastProvider>` and `<LocaleProvider>`.
 */
export function RateLimitToastBridge(): null {
  const { push } = useToast();
  const { t } = useLocale();
  useEffect(() => {
    setRateLimitNoticeListener((retryAfterSeconds) => {
      const message =
        retryAfterSeconds != null && retryAfterSeconds > 0
          ? t("errors.rate_limited.body_seconds", { seconds: retryAfterSeconds })
          : t("errors.rate_limited.body");
      push({
        tone: "warn",
        title: t("errors.rate_limited.title"),
        message,
      });
    });
    return () => setRateLimitNoticeListener(null);
  }, [push, t]);
  return null;
}
